import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import style from './style.css';
import common from '../../../../common/common';
import constants, { THEME_CONSTANTS } from '../../../../utils/constants';

class Web extends Component {
  render({
    themeColor,
    merchantPayModes,
    isPaytmBrandingDisplay,
    isGradientEffectEnable,
    gradientColor,
    selectedTheme,
    onInvertImgLogo,
    merchantLogoUrl
  }) {
    const headColor =
      isGradientEffectEnable && selectedTheme === 'CUSTOM'
        ? `background-image: linear-gradient(to bottom, ${gradientColor.headerGradientsColors[0]}, ${
            gradientColor.headerGradientsColors[1]
          }); color: ${themeColor.HEADERTEXT};`
        : `background: ${themeColor.HEADERPANEL}; color: ${themeColor.HEADERTEXT};`;
    const buttonbgColor =
      isGradientEffectEnable && selectedTheme === 'CUSTOM'
        ? `background-image: linear-gradient(to top, ${gradientColor.buttonGradientsColors[0]}, ${
            gradientColor.buttonGradientsColors[1]
          }); color: ${themeColor.PAYBUTTONTEXT};`
        : `background: ${themeColor.PAYBUTTONBG}; color: ${themeColor.PAYBUTTONTEXT};`;
    return (
      <div className={`${style.default} ${style['tab-content']}`}>
        <div className={`${style['webtheme-wrapper']}`}>
          <p className={`${style.tabcircle}`}>
            <span className={`${style.circle}`} />
            <span className={`${style.circle}`} />
            <span className={`${style.circle}`} />
          </p>
          <div className={`${style['webtheme-inner']}`}>
            <div
              className={`${style['web-wrap']}`}
              style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
            >
              <div className={`${style.header} header-bg`} style={headColor}>
                <div className={`${style['header-top']}`}>
                  <div className={`${style['cross-wrap']}`}>
                    <span
                      className={`${style.cross} ${style['cross-line1']}`}
                      style={`background: ${themeColor.HEADERTEXT};`}
                    />
                    <span
                      className={`${style.cross} ${style['cross-line2']}`}
                      style={`background: ${themeColor.HEADERTEXT};`}
                    />
                  </div>
                  {
                    <img
                      className={`${style['ptm-head-logo']}`}
                      src={common.getHeaderLogoUrl(onInvertImgLogo, themeColor)}
                      alt=""
                    />
                  }
                  {/* <span className={`select-txt`}></span> */}
                  {/* <div className={`${style['user-bg']} pos-a`}>
                    <img
                      className={`centralized`}
                      src={`${common.getStaticPath()}/assets/images/user.svg`}
                      alt="user"
                    />
                  </div> */}
                </div>
                <div className={`${style['header-bottom']} pos-r`}>
                  {/* <div className={`${style['logo-amount']}`}>
                    <div className={`${style['mer-logo']} left`}>
                      <img
                        className={`${style['brand-logo']}`}
                        src={`${common.getStaticPath()}/assets/images/merchant-logo-default.svg`}
                        alt="merchant logo"
                      />
                    </div>
                    <div
                      className={`${style.amount} right amount-color pos-r`}
                      style={`color: ${themeColor.HEADERTEXT}`}
                    >
                      ₹5,876
                      <span className={`h-dropdown arrow-down`} />
                    </div>
                  </div> */}
                  <div className={`${style.subheading} header-color`}>
                    {/* <div style={`color: ${themeColor.HEADERTEXT}`}>Order ID: BWK876411C</div> */}
                    <div className={`${style['mer-name']}`} style={`color: ${themeColor.HEADERTEXT}`}>
                      AJIO Online Shopping
                    </div>
                  </div>
                  <div className={`${style['mer-logo']} pos-a`}>
                    <img
                      className={`${style['brand-logo']}`}
                      src={merchantLogoUrl && merchantLogoUrl !== '' ? merchantLogoUrl : `${common.getStaticPath()}/assets/images/merc-default.svg`}
                      alt="merchant logo"
                    />
                  </div>
                </div>
              </div>

              <div
                className={`${style['m-content']}`}
                style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
              >
                <div className={`${style['select-txt']}`} style={`color: ${themeColor.BODYTEXT}`}>
                  Select an option to pay
                  <div className={`${style.amount} right amount-color pos-r`} style={`color: ${themeColor.BODYTEXT}`}>
                    &#x20B9;5,876
                  </div>
                </div>
                <div className={`${style.wallet} w100`} style={`border-color:${themeColor.BORDER}`}>
                  <h5 className={`${style['choose-txt']}`} style={`color: ${themeColor.BODYTEXT}`}>
                    Paytm Featured
                  </h5>
                  <div className={`${style['wallet-inner']}`}>
                    <div
                      className={`${style.check} left`}
                      style={`background: ${themeColor.PAYBUTTONBG}; color: ${themeColor.PAYBUTTONTEXT}`}
                    >
                      <span className={`${style.sign1}`} style={`background: ${themeColor.PAYBUTTONTEXT}`} />
                      <span className={`${style.sign2}`} style={`background: ${themeColor.PAYBUTTONTEXT}`} />
                    </div>
                    <div className={`${style['check-txt']} left`}>
                      <h6 className={`${style['wallet-txt']}`}>Paytm Balance</h6>
                      <p className={`${style['wallet-para']}`} style={`color: ${themeColor.BODYTEXT}`}>
                        Available Balance &#x20B9;12,000
                      </p>
                      <img
                        className={`${style['sc-img']}`}
                        src={`${common.getStaticPath()}/assets/images/pb-icon-new.svg`}
                        alt=""
                      />
                      <div style={buttonbgColor} className={`${style.payBtn}`}>
                        <img
                          className={`${style.payBtnimg} pos-r`}
                          src={`${common.getStaticPath()}/assets/images/lock.png`}
                          alt=""
                        />
                        Pay &#x20B9;5,876
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`${style['pay-list-wrap']}`} style={`border-color:${themeColor.BORDER}`}>
                  <h5 className={`${style['choose-txt']}`} style={`color: ${themeColor.BODYTEXT}`}>
                    Saved Cards
                  </h5>
                  <ul className={`${style['pay-list']}`}>
                    {/* <li>
                      <span className={`${style['radio-circle']}`} style={`border-color:${themeColor.BODYTEXT};`} />
                      <h5>
                        {' '}
                        <img
                          className={`${style['ptm-logo']}`}
                          src={`${common.getStaticPath()}/assets/images/logo-paytm.svg`}
                        />{' '}
                        Account{' '}
                      </h5>
                      <p style={`color:${themeColor.BODYTEXT};`}>Pay using your saved payment instruments</p>

                      <div className={`${style['border-div']} pos-a`} style={`background:${themeColor.BORDER}`} />
                    </li> */}
                    <li>
                      <span className={`${style['radio-circle']}`} style={`border-color:${themeColor.BODYTEXT};`} />
                      <h5>
                        HDFC Credit Card
                        <img
                          className={`${style.cardtype}`}
                          src={`${common.getStaticPath()}/assets/images/master.svg`}
                        />
                      </h5>
                      <p style={`color:${themeColor.BODYTEXT};`}> XXXX 2021</p>
                      <img
                        className={`${style['sc-img']}`}
                        src={`${common.getStaticPath()}/assets/images/hdfc-logo-new.png`}
                        alt=""
                      />
                      <div className={`${style['border-div']} pos-a`} style={`background:${themeColor.BORDER}`} />
                    </li>
                    <li>
                      <span className={`${style['radio-circle']}`} style={`border-color:${themeColor.BODYTEXT};`} />
                      <h5>
                        Axis Credit Card
                        <img className={`${style.cardtype}`} src={`${common.getStaticPath()}/assets/images/visa.svg`} />
                      </h5>
                      <p style={`color:${themeColor.BODYTEXT};`}>XXXX 8781</p>
                      <img
                        className={`${style['sc-img']}`}
                        src={`${common.getStaticPath()}/assets/images/axis-logo-new.png`}
                        alt=""
                      />
                      <div className={`${style['border-div']} pos-a`} style={`background:${themeColor.BORDER}`} />
                    </li>
                  </ul>
                </div>
                {/* <div className={`${style['view-all']}`} style={`border-color:${themeColor.BORDER}`}>
                  view all
                </div> */}
              </div>
              <div
                className={`${style['grid-content']}`}
                style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
              >
                <div className={`${style['grid-wrap']}`} style={`border-color:${themeColor.BORDER}`}>
                  <div className={`${style['grid-inner']}`}>
                    {merchantPayModes && merchantPayModes.length > 0 && (
                      <h5 className={`${style['select-txt']}`} style={`color: ${themeColor.BODYTEXT}`}>
                        New Payment Option
                      </h5>
                    )}
                    {merchantPayModes &&
                      merchantPayModes.map(paymodeObj => {
                        if (paymodeObj.type == constants.LOGIN) {
                          return null;
                        }
                        let paymodeName = paymodeObj.name;
                        if (paymodeObj.type == 'CARD') {
                        paymodeName = constants.CARD_NAME;
                        }
                        if (paymodeObj.type == 'UPI') {
                        paymodeName = constants.UPI;
                    }
                        return (
                          <div className={`${style.grid}`} style={`border-color:${themeColor.BORDER}`}>
                            <div className={`${style['pay-method']} pos-r`}>
                              <img
                                className={`${style['grid-img']}`}
                                src={`${common.getStaticPath()}/assets/images/${`${
                                  THEME_CONSTANTS.DARK == themeColor.NAME ? `${paymodeObj.type}.dark` : paymodeObj.type
                                }.svg`}`}
                              />
                              <span>{paymodeName}</span>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
                {/* <ul className={`${style['pay-list']}`}>
                  {merchantPayModes &&
                    merchantPayModes.map(paymodeObj => {
                      if (paymodeObj.type == constants.LOGIN) {
                        return (
                          <li style={`border-bottom: 1px solid ${themeColor.BORDER}`}>
                            <span
                              className={`${style['radio-circle']}`}
                              style={`border-color:${themeColor.BODYTEXT};`}
                            />
                            <h5>
                              {' '}
                              <img src={`${common.getStaticPath()}/assets/images/logo-paytm.svg`} /> Account{' '}
                            </h5>
                            <p style={`color:${themeColor.BODYTEXT};`}>
                              Pay using your saved payment instruments
                            </p>
                            
                            <div className={`${style['border-div']} pos-a`} style={`background:${themeColor.BORDER}`}></div>
                          </li>
                        );
                      }
                      return (
                        <li style={`border-bottom: 1px solid ${themeColor.BORDER}`}>
                          <span className={`${style['radio-circle']}`} style={`border-color:${themeColor.BODYTEXT};`} />
                          <h5>{paymodeObj.name}</h5>
                        </li>
                      );
                    })}
                </ul> */}
              </div>
              {isPaytmBrandingDisplay && (
                <div
                  className={`${style['m-footer']}`}
                  // style={`background: ${themeColor.BODYBG}; color: ${themeColor.BODYTEXT}`}
                >
                  <img className={`${style.secure}`} src={`${common.getStaticPath()}/assets/images/secure.png`} />
                  100% Secure Payments Powered by Paytm
                </div>
              )}
              {/* <div style={`background: ${themeColor.BODYBG};`} className={`${style.payBtnWrap}`}>
                <div style={buttonbgColor} className={`${style.payBtn}`}>
                  <img
                    className={`${style.payBtnimg} pos-r`}
                    src={`${common.getStaticPath()}/assets/images/lock.png`}
                    alt=""
                  />
                  Pay &#x20B9;5,876
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  'merchantPayModes, timestamp, isPaytmBrandingDisplay, isGradientEffectEnable,onInvertImgLogo',
  null
)(Web);



// WEBPACK FOOTER //
// ./checkout/components/jscheckout/web/index.js